import { useChargerCreateStore } from './useChargerCreateStore';

export const customModalsConfig = [
  {
    key: 'charger',
    import: () => import('../views/CreateCharger'),
    store: useChargerCreateStore,
  },
];